import {UrlObj} from "./other/UrlObj";
import {ServerService} from "../services/server.service";

export class CittaData {
  id?: number;
  nome?: string;
  provincia?: number;
  codice_catastale?: string;

}

export class Citta {

  data:CittaData = {}

  constructor(data:CittaData) {
    // assegno al mio oggetto data (è un json)
    if(!data) data = {}
    Object.assign(this.data, data)

  }

   public static BASE_URL(path=null, queryParams={}):string{
      let url:UrlObj = new UrlObj(`/api/citta`, queryParams);
      if(path) url.url += path;
      return url.toString()
   }

   static async getCitta(provincia_id):Promise<Citta[]> {
     return new Promise((resolve, reject) => {
        ServerService.instance.getAll(Citta, `/api/citta/${provincia_id}`).then(res=>{
           resolve(res)
        }).catch(err=>{
           reject(err)
        })
     })
   }

}
